// extracted by mini-css-extract-plugin
export var button = "_5q-4";
export var hasDarkBackground = "_5q-7";
export var hasLightBackground = "_5q-6";
export var iconWrapper = "_5q-0";
export var large = "_5q-2";
export var medium = "_5q-1";
export var small = "_5q-5";
export var xsmall = "_5q-3";